import { SimpleProduct, GroupedProduct, ProgramType } from './types';

const groupedProductImage = 'https://placeholder.pagebee.io/api/plain/1360/636';
const simpleProductImage = 'https://placeholder.pagebee.io/api/plain/240/240';

export const groupedProduct_1: GroupedProduct = {
  id: 'sku-123',
  image: groupedProductImage,
  title: 'Набор для очень сухой, атопичной кожи',
  subtitle:
    'Программа ухода для очень сухой и атопичной кожей увлажняет, питают кожу, при этом смягчая ее и восстанавливая липидный баланс',
  alt: 'Набор',
  labels: [
    {
      color: 'orange',
      name: 'Выгода 20%'
    }
  ],
  brandLabels: [
    {
      color: '#003A70',
      name: 'Bioderma',
      url: '/bioderma'
    }
  ],
  prices: {
    price: 5890,
    oldPrice: 6930
  }
};

export const groupedProduct_2: GroupedProduct = {
  id: 'sku-123',
  image: groupedProductImage,
  title: 'Набор «Очищение + Уход для сухой атопичной кожи»',
  subtitle:
    'Программа ухода для очень сухой и атопичной кожей увлажняет, питают кожу, при этом смягчая ее и восстанавливая липидный баланс.',
  alt: 'Набор',
  labels: [
    {
      color: 'yellow',
      name: 'Выгода 15%'
    }
  ],
  brandLabels: [
    {
      color: '#003A70',
      name: 'Bioderma',
      url: '/bioderma'
    }
  ],
  prices: {
    price: 5890,
    oldPrice: 5670
  }
};

export const simpleProducts: SimpleProduct[] = [
  {
    id: 1,
    image: simpleProductImage,
    link: '/',
    title: 'Atoderm РР бальзам, 200 мл',
    subtitle: 'Питание и увлажнение',
    alt: 'Atoderm РР бальзам',
    prices: {
      price: 2430
    }
  },
  {
    id: 2,
    image: simpleProductImage,
    link: '/',
    title: 'Atoderm Масло для душа, 1 л',
    subtitle: 'Экзема',
    alt: '',
    prices: {
      price: 999,
      oldPrice: 1999
    }
  },
  {
    id: 3,
    image: simpleProductImage,
    link: '/',
    title: 'Atoderm Бальзам для губ, 15 мл',
    subtitle: 'Уход за губами',
    alt: '',
    prices: {
      price: 1150
    }
  },
  {
    id: 4,
    image: simpleProductImage,
    link: '/',
    title: 'Подарок',
    subtitle: 'Косметичка BIODERMA',
    alt: '',
    prices: {
      price: 0
    }
  }
];

export const programs: ProgramType[] = [
  {
    id: 1,
    title: 'Для очень сухой атопичной кожи',
    grouped: groupedProduct_1,
    products: simpleProducts
  },
  {
    id: 2,
    title: 'Очищение + Уход для сухой атопичной кожи',
    grouped: groupedProduct_2,
    products: [simpleProducts[1], simpleProducts[3]]
  }
];
